import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { UserOperationsType } from '../models/UsersModels';

interface ESimManagerStateData {
  userOperations: UserOperationsType[];
}

const initialState: ESimManagerStateData = {
  userOperations: [],
};

export const ESimManagerSlice = createSlice({
  name: 'eSimManager',
  initialState,
  reducers: {
    reset: () => initialState,
    setUserOperations: (state, action: PayloadAction<UserOperationsType[]>) => {
      state.userOperations = action.payload;
    },
  },
});

export const { reset, setUserOperations } = ESimManagerSlice.actions;

export default ESimManagerSlice.reducer;
